import { Variants } from 'framer-motion';

export const svgAnim: Variants = {
  init: {},
  anim: {
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1
    }
  }
};

export const pathAnim: Variants = {
  init: (i: number) => ({
    opacity: 1,
    transition: {
      duration: 0.6
    }
  }),
  anim: (i: number) => ({
    opacity: [null, 0.5, 1, i === 1 ? 1 : (3 - i + 1) / 4],
    scale: [null, 0.5, 1.3, 1],
    transition: {
      duration: 0.6,
      repeatDelay: 2.2,
      repeat: Infinity
    }
  })
};

export const highlightAnim: Variants = {
  init: {
    rotateZ: -65,
    transition: { ease: 'linear', duration: 0.001 }
  },
  anim: {
    rotateZ: [null, 65],
    transition: {
      ease: [0.5, 1, 0.89, 1],
      duration: 1.3,
      repeat: Infinity
    }
  }
};
